import { render, staticRenderFns } from "./contractNewDetail.vue?vue&type=template&id=d25ba526&scoped=true"
import script from "./contractNewDetail.vue?vue&type=script&lang=js"
export * from "./contractNewDetail.vue?vue&type=script&lang=js"
import style0 from "./contractNewDetail.vue?vue&type=style&index=0&id=d25ba526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25ba526",
  null
  
)

export default component.exports